export { ContactsDirectoryModule } from './contacts-directory.module';
export * from './types';
